import { defineStore } from 'pinia';
import router from "@/router";
import axios from "axios";
import StoreCache from "@/js/storeCache";
import ApiHelper from "@/helpsers/api.helper";
import storeCache from "@/js/storeCache";
import UserService from "@/services/user.service";

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        user: StoreCache.get('user'),
        userInfo: '',
        returnUrl: null,
        isLoading: false,
    }),
    actions: {
        login(email, password, rememberUser = false) {
            try {
                this.isLoading = true;

                return axios.post(ApiHelper.loginUrl(), {
                    email: email,
                    password: password,
                    rememberUser: rememberUser
                }).then(response => {
                    this.user = {
                        id: response.data.user.id,
                        email: response.data.user.email,
                        accessToken:  response.data.accessToken,
                        tokenExpirationTime: response.data.tokenExpirationTime,
                        role: response.data.user.role,
                        firstName: response.data.user.firstName,
                        lastName: response.data.user.lastName,
                    }
                    // redirect to previous url or default to home page
                     router.push(this.returnUrl || '/my-profile');
                    this.isLoading = false;
                    storeCache.set('user',this.user);

                    return Promise.resolve(this.user);
                }).catch(error => {
                    return Promise.reject(error);
                })

            }
            catch (e) {
                this.isLoading = false;
                throw e;
            }
        },

        loginGoogle(jwt) {
            try {
                this.isLoading = true;

                return axios.post(ApiHelper.loginGoogle(), {
                    token: jwt,
                }).then(response => {
                    this.user = {
                        id: response.data.user.id,
                        email: response.data.user.email,
                        accessToken:  response.data.accessToken,
                        tokenExpirationTime: response.data.tokenExpirationTime,
                        role: response.data.user.role,
                        firstName: response.data.user.firstName,
                        lastName: response.data.user.lastName,
                        needToChooseRole: response.data.needToChooseRole,
                    }
                    // redirect to previous url or default to home page
                    this.isLoading = false;
                    storeCache.set('user',this.user);

                    if(response.data.needToChooseRole)
                        router.push(this.returnUrl || '/accept-of-terms');
                    else
                        router.push(this.returnUrl || '/my-profile');

                    return Promise.resolve(this.user);
                }).catch(error => {
                    return Promise.reject(error);
                })

            }
            catch (e) {
                this.isLoading = false;
                throw e;
            }
        },

        loginFacebook(token) {
            try {
                this.isLoading = true;

                return axios.post(ApiHelper.loginFacebook(), {
                    token: token,
                }).then(response => {
                    this.user = {
                        id: response.data.user.id,
                        email: response.data.user.email,
                        accessToken:  response.data.accessToken,
                        tokenExpirationTime: response.data.tokenExpirationTime,
                        role: response.data.user.role,
                        firstName: response.data.user.firstName,
                        lastName: response.data.user.lastName,
                        needToChooseRole: response.data.needToChooseRole,
                    }
                    // redirect to previous url or default to home page
                    router.push(this.returnUrl || '/my-profile');
                    this.isLoading = false;
                    storeCache.set('user',this.user);

                    if(response.data.needToChooseRole)
                        router.push(this.returnUrl || '/accept-of-terms');
                    else
                        router.push(this.returnUrl || '/my-profile');

                    return Promise.resolve(this.user);
                }).catch(error => {
                    return Promise.reject(error);
                })

            }
            catch (e) {
                this.isLoading = false;
                throw e;
            }
        },

        logout() {
            this.user = null;
            this.userInfo = null;
            storeCache.remove('user');

            router.go('/login');
        },

        saveUserInfo(user) {
            const userService = new UserService();
            userService.getUserProfileImage(user.profilePhotoId)
                .then(result => {
                    console.log(result);
                    this.userInfo.profilePhotoBlob = result;
                })
            this.userInfo = user;
        },

        updateNeedToChooseRole(needToChooseRole = false) {
            this.user.needToChooseRole = needToChooseRole;
            storeCache.set('user',this.user);
            console.log(this.user);
        }
    }
});
